const useIsIOS = (): boolean => {
  const checkIsIOS = () => {
    // Check user agent for iOS devices
    const userAgentCheck = /iPad|iPhone|iPod/.test(navigator.userAgent)

    // Check for iOS 13+ iPad (reports as Mac but has touch)
    const iPadProCheck =
      navigator.userAgent.includes('Mac') && 'ontouchend' in document

    return userAgentCheck || iPadProCheck
  }

  return checkIsIOS()
}

export default useIsIOS
